import { Injectable } from '@angular/core';
import { Server } from '../_shared/models/point.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IntennseService {
    private firstTimeServer: Server | null = null;
    private swapSidesSubject = new Subject<void>();
    private teamSideNumber: number;
        // Observable to notify when swapSides() should be called
    swapSides$ = this.swapSidesSubject.asObservable();
    isBreakClockStart: boolean = false;

    constructor() { }

    setFirstTimeServer(server: Server) {
        this.firstTimeServer = server;
    }

    getFirstTimeServer(): Server | null {
        return this.firstTimeServer;
    }

    setTeamSelection(sdeNumber: number) {
        this.teamSideNumber = sdeNumber;
    }

    getTeamSelection(): number | null {
        return this.teamSideNumber;
    }

    // Method to trigger the swapSides event
    triggerSwapSides() {
        this.swapSidesSubject.next();
    }
}
